// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3Eqiw","text":"SelectPayment_text__1wa9g","title":"SelectPayment_title__35qtG","btn":"SelectPayment_btn__2KQkb"};